import { isNull } from 'lodash';
import APIEndpoints from '../utils/apiEndpoints';
import AbstractService from './abstractService';

// Singleton instance
let instance = null;

const _SERVICE_UNAVAILABLE_ = new Error({ message : 'Service Unavailable' });

export default class PaymentService extends AbstractService {
	static setup(baseURL, options) {
		instance = new PaymentService(baseURL, options);
	}

	static getInstance() {
		return instance;
	}

	constructor(baseURL, options) {
		super(baseURL, options);
		const payments = `${APIEndpoints.accounts}/${APIEndpoints.payments}`;

		this.endpoints = {
			payments,
			paymentMethods       : `${APIEndpoints.accounts}/${APIEndpoints.paymentMethods}`,
			payouts              : `${APIEndpoints.payouts}/`,
			verificationdocument : `${payments}/verificationdocument`,
		};
	}

	static save(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._save(...params);
	}

	static getData(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getData(...params);
	}

	static getPayouts(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getPayouts(...params);
	}

	static addPaymentMethod(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._addPaymentMethod(...params);
	}

	static setPreferredCard(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._setPreferredCard(...params);
	}

	static deletePaymentMethod(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._deletePaymentMethod(...params);
	}

	static verifyBankAccount(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._verifyBankAccount(...params);
	}

	static makePayment(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._makePayment(...params);
	}

	static verifyBulkPaymentStatus(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._verifyBulkPaymentStatus(...params);
	}

	static makeQuickPayPayment(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._makeQuickPayPayment(...params);
	}

	static makeBulkQuickPayPayment(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._makeBulkQuickPayPayment(...params);
	}

	static remindOfficerSubmit(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._remindOfficerSubmit(...params);
	}

	_save({ data, editMode }) {
		return this.request({
			endpoint : this.endpoints.payments,
			method   : !editMode ? 'POST' : 'PUT',
			data,
		});
	}

	_getData() {
		return this.get({
			endpoint : this.endpoints.payments,
		});
	}

	_getPayouts({ pagingToken, displayCount = 25 }) {
		return this.get({
			endpoint    : this.endpoints.payouts,
			queryParams : {
				pagingToken,
				displayCount,
			},
		});
	}

	_addPaymentMethod(data) {
		return this.post({
			endpoint : this.endpoints.paymentMethods,
			data,
		});
	}

	_setPreferredCard(cardId) {
		return this.post({
			endpoint : `${this.endpoints.paymentMethods}/${cardId}`,
		});
	}

	_deletePaymentMethod(id) {
		return this.del({
			endpoint : `${this.endpoints.paymentMethods}/${id}`,
		});
	}

	_verifyBankAccount(data) {
		return this.post({
			endpoint : `${this.endpoints.payments}/verify`,
			data,
		});
	}

	_makePayment(PaymentCardId, Amount, InvoiceIds) {
		return this.post({
			endpoint : APIEndpoints.payments,
			data     : {
				PaymentCardId,
				Amount,
				InvoiceIds,
			},
		});
	}

	_verifyBulkPaymentStatus(JobId) {
		return this.get({
			endpoint    : `${APIEndpoints.payments}/status/`,
			queryParams : { JobId },
		});
	}

	_makeQuickPayPayment(data) {
		return this.post({
			endpoint : `${APIEndpoints.payments}/quickpay`,
			data,
		});
	}

	_makeBulkQuickPayPayment(data) {
		return this.post({
			endpoint : `${APIEndpoints.payments}/quickpay/bulk`,
			data,
		});
	}

	_remindOfficerSubmit(id) {
		return this.post({
			endpoint : `${APIEndpoints.invoices}/${id}/remind`,
		});
	}
}
